import {Component, HostListener, OnInit} from '@angular/core';
import {ASCII_REMOTE_KEYS} from '../../core/services/remote-control.service';
import {Router} from '@angular/router';

@Component({
    selector: 'cm-datetime-viewer-container',
    templateUrl: './datetime-viewer-container.component.html',
    styleUrls: ['./datetime-viewer-container.component.scss'],
    standalone: false
})
export class DatetimeViewerContainerComponent implements OnInit {

  constructor(private readonly router: Router) { }

  ngOnInit(): void {
  }

  @HostListener('document:keydown', ['$event'])
  onKeyDown($event: KeyboardEvent): boolean {
    if ($event.keyCode === ASCII_REMOTE_KEYS.back) {
      this.goToMenu();
    }
    return false;
  }

  goToMenu(): void {
    this.router.navigate(['dashboard/menu']);
  }
}
